import { createFileRoute } from '@tanstack/react-router';
import { WorkSheetAdditionalProtocolPage } from '@/features/work-orders/components/worksheet-detail/WorkSheetAdditionalProtocolPage';

export const Route = createFileRoute('/_authenticated/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId')({
	component: WorkSheetAdditionalProtocol,
});

function WorkSheetAdditionalProtocol() {
	const { id, worksheetId, additionalProtocolId } = Route.useParams();
	return <WorkSheetAdditionalProtocolPage workOrderId={id} worksheetId={worksheetId} additionalProtocolId={additionalProtocolId} />;
}
